import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  constructor(private config: ConfigService, private http: HttpClient) { }

  eventSource!: EventSource;

/* 
  setNotify = (token: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    });
    const url = this.config.urlService + 'api/Notify';
    return this.http.post(url, {}, requestOptions);
  } */


 /*  subscribeService = (token: string) => {

    return new Observable(obs => {
    
          const requestOptions = new Object({
            headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
            responseType: 'text'
          });
          // es necesario subscribirse para recibir los mensajes
          this.eventSource = new EventSource(this.config.urlService + 'api/Notify/subscribe', requestOptions);
    
          this.eventSource.onerror = (error) => {
            console.log(error);
          }
    
          this.eventSource.onmessage = (message) => {
            obs.next(message.data);
          }
        }); 
  } */
}
